Ext.define('SA.view.LocationRenderer', {
    aliasCls: 'sa-locations-list-alias',
    aliasNameCls: 'sa-locations-list-alias-name',
    comboIconHref: 'sa-icon-combination-location',
    radiusIconHref: 'sa-icon-radius-location',

    constructor({svgIconCls}) {
        this.svgIconCls = svgIconCls;
        this.htmlEncode = Ext.String.htmlEncode;
    },

    renderAliasedLocation(location) {
        var aliasEncoded = this.htmlEncode(location.getAlias()),
            nameEncoded = this.htmlEncode(location.getName());

        return [
            '<span>',
                `<span class="${this.aliasCls}">${aliasEncoded}</span>`,
                ' \u00A0',
                `<span class="${this.aliasNameCls}">[${nameEncoded}]</span>`,
            '</span>'
        ].join('');
    },

    renderCustomLocation(location) {
        var nameEncoded = this.htmlEncode(location.getName()),
            icon = location.isCombo() ? this.comboIconHref : this.radiusIconHref;

        return [
            `<svg class="${this.svgIconCls}">`,
                `<use href="#${icon}"></use>`,
            '</svg>',
            nameEncoded
        ].join('');
    },

    renderLocation(location) {
        if (location.isCustom()) {
            return this.renderCustomLocation(location);
        }
        else if (location.hasAlias()) {
            return this.renderAliasedLocation(location);
        }

        return this.htmlEncode(location.getName());
    }
});